import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, Badge, ModalFooter } from 'reactstrap'
import Select from '../../components/Select'
import ReactLoading from 'react-loading'
import auth from '../../utils/auth'
import cfg from '../../utils/config'
import axios from 'axios'
import GenericInputDate from '../../components/GenericInputDate'

export default class Logs extends React.Component {
    userInfo = auth.getUserInfo()
    configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

    optionsAcao = [
        { label: "Todas as Ações", value: false },
        { label: "Cadastrou", value: "Cadastrou" },
        { label: "Editou", value: "Editou" },
        { label: "Deletou", value: "Deletou" },
        { label: "Enviou", value: "Enviou" }
    ]

    state = {
        logs: [],
        carregando_dados: false,
        detalhes: { data: '' },
        usuario: false,
        tela: false,
        acao: false,
        modal: false,
        log: { valor_novo: '', valor_atual: '' },
        semResultado: false,
        optionsUsuario: [],
        optionsTela: []
    }

    componentDidMount() {
        this.getData()
    }

    getData = () => {
        const base = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}`

        axios.get(base + '/log-acessos-select/', this.configMe)
            .then((response) => {
                const { usuarios, telas } = response.data
                let optionsUsuario = [{ label: "Nenhum", value: false }]

                for (let i in usuarios) {
                    optionsUsuario.push({ label: usuarios[i], value: i })
                }
                
                this.setState({ optionsUsuario, optionsTela: telas ?? [] })
            })
    }

    handleInput = (name, e) => {
        this.setState({ [name]: e.value === "todas" ? false : e.value })
    }

    changeDate = (objectDate) => {
        let detalhes = {...this.state.detalhes}
        detalhes.data = objectDate

        this.setState({ detalhes: detalhes })
    }

    filtrar = () => {
        this.setState({ carregando_dados: true })
        let { detalhes, tela, usuario, acao } = this.state

        const config = { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() } }
        let data = {
            data_inicio: detalhes.data.startDate,
            data_fim: detalhes.data.endDate,
            tela: tela,
            usuario: usuario,
            acao: acao
        }

        axios.post(cfg.base_api_url + cfg.api_v2 + `/${auth.getUserInfo().empresa}/log-acessos/`, JSON.stringify(data), config)
        .then(res => {
            if (!res.data)
                this.setState({ semResultado: true, logs: res.data, carregando_dados: false })
            else {
                let logs = res.data ?? []
                logs.reverse()
                this.setState({ logs, carregando_dados: false, semResultado: false })
            }
        })
        .catch(console.error)
    }

    convertToDate(stamp) {
        return new Date(stamp * 1000).toLocaleDateString("pt-BR", { hour: 'numeric', minute: 'numeric' })
    }

    handleDescricao = (descricao) => {
        let icon = null
        let label = descricao

        if (descricao.includes('Cadastrou')) {
            icon = "fa fa-plus"
            label = "Cadastrou"
        } else if (descricao.includes('Editou')) {
            icon = "fa fa-pen"
            label = "Editou"
        } else if (descricao.includes('Deletou')) {
            icon = "fa fa-trash"
            label = "Deletou"
        } else if (descricao.includes('Desativou')) {
            icon = "fa fa-ban"
            label = "Desativou"
        } else if (descricao.includes('Enviou')) {
            icon = "fa fa-long-arrow-alt-up"
            label = "Enviou"
        } else if (descricao.includes('Removeu')) {
            icon = "fa fa-trash"
            label = "Removeu"
        } else if (descricao.includes('Falha')) {
            icon = "fa fa-exclamation-triangle"
            label = "Falha"
        } else if (descricao.includes('Confirmou')) {
            icon = "fa fa-check"
            label = "Confirmou"
        }

        if (icon)
            return (<><i style={{ fontSize: '18px' }} className={icon}></i> {label}</>)
        else
            return label
    }

    orderData = () => {
        let { logs } = this.state
        this.setState({ logs: logs.reverse() })
    }

    getRowBorderColor = (descricao) => {
        if (!descricao) return undefined
        if (descricao.includes('Deletou')) return '#dc3545'
        if (descricao.includes('Removeu')) return '#dc3545'
        if (descricao.includes('Cadastrou')) return '#28a745'
        if (descricao.includes('Editou')) return '#ffc107'
        if (descricao.includes('Falha')) return '#fd7e14'
        if (descricao.includes('Confirmou')) return '#17a2b8'
        return undefined
    }

    parseValue = (value) => {
        if (typeof value === 'string') {
            try {
                return JSON.parse(value)
            } catch (e) {
                return value
            }
        }
        return value
    }

    isContainer = (v) => v !== null && typeof v === 'object'

    formatJSONValue = (value) => {
        if (value === undefined) return 'null'
        return JSON.stringify(value)
    }

    pushWholeValue = (lines, type, keyLabel, indent, value, comma) => {
        if (this.isContainer(value)) {
            const wholeLines = JSON.stringify(value, null, 2).split('\n')
            wholeLines[0] = `${indent}${keyLabel}${wholeLines[0]}`
            for (let k = 1; k < wholeLines.length; k++) wholeLines[k] = `${indent}${wholeLines[k]}`
            wholeLines[wholeLines.length - 1] += comma
            wholeLines.forEach((text) => lines.push({ type, text }))
        } else {
            lines.push({ type, text: `${indent}${keyLabel}${this.formatJSONValue(value)}${comma}` })
        }
    }

    buildDiffLines = (oldValue, newValue, level = 0) => {
        const indent = '  '.repeat(level)
        const childIndent = '  '.repeat(level + 1)
        const isArr = Array.isArray(oldValue) || Array.isArray(newValue)

        let oldSafe, newSafe, keys
        if (isArr) {
            oldSafe = Array.isArray(oldValue) ? oldValue : []
            newSafe = Array.isArray(newValue) ? newValue : []
            keys = Array.from({ length: Math.max(oldSafe.length, newSafe.length) }, (_, idx) => idx)
        } else {
            oldSafe = this.isContainer(oldValue) && !Array.isArray(oldValue) ? oldValue : {}
            newSafe = this.isContainer(newValue) && !Array.isArray(newValue) ? newValue : {}
            const newKeys = Object.keys(newSafe)
            const oldOnlyKeys = Object.keys(oldSafe).filter((k) => !newKeys.includes(k))
            keys = [...newKeys, ...oldOnlyKeys]
        }

        const openChar = isArr ? '[' : '{'
        const closeChar = isArr ? ']' : '}'

        if (keys.length === 0) {
            return [{ type: 'normal', text: `${indent}${openChar}${closeChar}` }]
        }

        let lines = [{ type: 'normal', text: `${indent}${openChar}` }]

        keys.forEach((key, idx) => {
            const hasOld = isArr ? key < oldSafe.length : Object.prototype.hasOwnProperty.call(oldSafe, key)
            const hasNew = isArr ? key < newSafe.length : Object.prototype.hasOwnProperty.call(newSafe, key)
            const oldVal = oldSafe[key]
            const newVal = newSafe[key]
            const keyLabel = isArr ? '' : `"${key}": `
            const comma = idx < keys.length - 1 ? ',' : ''

            const bothContainers = this.isContainer(oldVal) && this.isContainer(newVal) && Array.isArray(oldVal) === Array.isArray(newVal)

            if (bothContainers) {
                const nested = this.buildDiffLines(oldVal, newVal, level + 1)
                nested[0] = { ...nested[0], text: `${childIndent}${keyLabel}${nested[0].text.trim()}` }
                nested[nested.length - 1] = { ...nested[nested.length - 1], text: `${nested[nested.length - 1].text}${comma}` }
                lines = lines.concat(nested)
                return
            }

            if (hasOld && hasNew && JSON.stringify(oldVal) === JSON.stringify(newVal)) {
                lines.push({ type: 'normal', text: `${childIndent}${keyLabel}${this.formatJSONValue(newVal)}${comma}` })
                return
            }

            if (hasOld) this.pushWholeValue(lines, 'removed', keyLabel, childIndent, oldVal, comma)
            if (hasNew) this.pushWholeValue(lines, 'added', keyLabel, childIndent, newVal, comma)
        })

        lines.push({ type: 'normal', text: `${indent}${closeChar}` })
        return lines
    }

    renderDiffLines = (oldValue, newValue) => {
        const diffStyles = {
            normal: { padding: '1px 8px', color: '#333' },
            removed: { padding: '1px 8px', backgroundColor: '#ffeef0', color: '#86181d' },
            added: { padding: '1px 8px', backgroundColor: '#e6ffed', color: '#22863a' }
        }
        const linePrefix = { normal: '  ', removed: '- ', added: '+ ' }

        return this.buildDiffLines(oldValue, newValue).map((line, index) => (
            <div key={index} style={{ ...diffStyles[line.type], whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {linePrefix[line.type]}{line.text}
            </div>
        ))
    }

    render() {
        const { carregando_dados, logs, log, semResultado, optionsTela, optionsUsuario } = this.state

        const descricao = log.descricao || ''
        const valorAtual = descricao.includes('Cadastrou') ? {} : this.parseValue(log.valor_atual)
        const valorNovo = descricao.includes('Deletou') ? {} : this.parseValue(log.valor_novo)

        return (
            <div className="hdv-render-div">
                {this.state.modal ?
                    <Modal size="lg" isOpen={this.state.modal} toggle={() => this.setState({ modal: !this.state.modal })}>
                        <ModalHeader
                            toggle={() => this.setState({ modal: !this.state.modal })}>
                            Alteração
                        </ModalHeader>
                        <ModalBody>
                            <div className="log-json-tree" style={{ fontFamily: 'monospace', fontSize: '13px', overflowX: 'auto', maxHeight: '65vh', overflowY: 'auto' }}>
                                {this.renderDiffLines(valorAtual, valorNovo)}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="default"
                                onClick={() => this.setState({ modal: !this.state.modal })}>
                                Fechar
                            </Button>
                        </ModalFooter>
                    </Modal>
                    :
                    null
                }

                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc">
                        <h4>Logs de Acesso</h4>
                        <div className="gray-background">
                            <i className="fa fa-file-alt fa-2x"></i>
                        </div>
                    </span>
                    <ReactLoading className={(this.state.carregando_dados) ? "hdv-report-loading" : "hdv-noshow-item"} type="cylon" color="var(--background-menu)" width={50} />
                </div>

                <details open={true} className="custom-summary">
                    <summary>Filtros</summary>
                    <div style={{ padding: "20px" }} className="hdv-form-default pt-0">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="required">Periodo</label>
                                <GenericInputDate
                                    onChange={(objectDate) => this.changeDate(objectDate)}
                                    haveInitialValue
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="required">Usuário</label>
                                <Select
                                    onChange={(e) => this.handleInput('usuario', e)}
                                    options={optionsUsuario}
                                    defaultValue={{ label: "Nenhum", value: false }}
                                />
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label className="required">Ação</label>
                                <Select
                                    onChange={(e) => this.handleInput('acao', e)}
                                    options={this.optionsAcao}
                                    defaultValue={{ label: "Todas as Ações", value: false }}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="required">Tela</label>
                                <Select
                                    onChange={(e) => this.handleInput('tela', e)}
                                    options={optionsTela}
                                    defaultValue={{ label: "Todas as Telas", value: false }}
                                />
                            </div>
                        </div>
                    </div>
                </details>

                <div className="hdv-btn-group">
                    <button disabled={carregando_dados} onClick={() => this.filtrar()} className="hdv-btn-forms hdv-btn-blue">Gerar Relatório</button>
                </div>

                {!semResultado ?
                    <table className="table afira-table">
                        {logs.length > 0 ?
                            <thead>
                                <tr>
                                    <th onClick={() => this.orderData()} style={{ cursor: 'pointer' }}>
                                        Data <i className="fa fa-sort"></i>
                                    </th>
                                    <th>Usuário</th>
                                    <th>Ação</th>
                                    <th>Tela</th>
                                    <th></th>
                                </tr>
                            </thead>
                            : null}
                        <tbody>
                            {this.state.logs.map((log, index) => {
                                const borderColor = this.getRowBorderColor(log.descricao)
                                return (
                                    <tr
                                        key={index}
                                        className={borderColor ? 'hdv-log-row' : ''}
                                        style={borderColor ? { '--log-row-color': borderColor } : undefined}
                                    >
                                        <td>{this.convertToDate(log.timestamp)}</td>
                                        <td>{log.usuario}</td>
                                        <td>{this.handleDescricao(log.descricao)}</td>
                                        <td>{log.tela}</td>
                                        {log.valor_atual || log.valor_novo !== "{}"
                                            ? <td>
                                                <Badge
                                                    color="primary"
                                                    style={{ padding: '6px 16px', cursor: 'pointer', fontSize: '12px' }}
                                                    onClick={() => this.setState({ modal: true, log })}>
                                                    Ver
                                                </Badge>
                                            </td>
                                            :
                                            <td>---</td>
                                        }
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    :
                    <p style={{ textAlign: "center", fontWeight: "bold" }}>Não houve resultados</p>
                }
            </div>
        )
    }
}